import React, { useRef, useState } from 'react'

import './styles.css'

import { FormControl, InputLabel, MenuItem, Select, Snackbar, TextField } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { styled } from '@mui/material/styles'
import Copyright from 'src/common/components/Copyright'
import { useQuery } from 'src/hooks'
import { useEffect } from 'react'
import CustomCheckbox from 'src/common/components/CustomCheckbox'
import companyService from 'src/services/company.service'

const LoginInput = styled(TextField)(() => ({
  border: '1px solid #E7E7EE',
  padding: '10px 16px',
  fontSize: '16px',
  '& .MuiFormLabel-root': {
    fontSize: '16px',
    left: '16px',
    top: '4px'
  },
  '& .MuiFormLabel-root.MuiFormLabel-filled': {
    top: '10px',
    fontSize: '14px'
  },
  '& .MuiFormLabel-root.Mui-focused': {
    fontSize: '14px',
    color: '#76767F',
    top: '10px'
  },
  '& .MuiInput-root:before': {
    display: 'none'
  },
  '& .MuiInput-root:after': {
    display: 'none'
  }
}))

export const InputSelect = styled(Select)(() => ({
  padding: '10px 16px',
  fontSize: '16px',

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E7E7EE'
  },

  '& .MuiFormLabel-root': {
    fontSize: '16px',
    left: '16px',
    top: '4px'
  },
  '& .MuiFormLabel-root.MuiFormLabel-filled': {
    top: '10px',
    fontSize: '14px'
  },
  '& .MuiFormLabel-root.Mui-focused': {
    fontSize: '14px',
    color: '#76767F',
    top: '10px'
    // left: '16px',
  },
  '& .MuiInput-root:before': {
    display: 'none'
  },
  '& .MuiInput-root:after': {
    display: 'none'
  },

  '& .MuiInputLabel-root': {
    top: '12px'
  }
}))

export const INDUSTRIES = [
  'Manufacturing',
  'Banking and Finance',
  'Healthcare and Pharmaceuticals',
  'Technology and Software',
  'Retail and Consumer Goods',
  'Energy and Utilities',
  'Transportation and Logistics',
  'Agriculture and Food Production',
  'Construction and Real Estate',
  'Education and Training',
  'Entertainment and Media',
  'Hospitality and Tourism',
  'Professional Services (including consulting, legal, and accounting services)',
  'Telecommunications',
  'Automotive',
  'Other'
]

const LANGUAGES = [
  'Czech',
  'Danish',
  'Dutch',
  'English',
  'Finnish',
  'French',
  'German',
  'Greek',
  'Hungarian',
  'Italian',
  'Polish',
  'Portuguese',
  'Romanian',
  'Spanish',
  'Swedish'
]

const RegistrationPage = () => {
  const query = useQuery()

  const [form, setForm] = useState({
    email: '',
    name: '',
    lastName: '',
    companyName: '',
    industry: '',
    language: ''
  })

  const [tsAndCsRead, setTsAndCsRead] = useState(false)
  const [formHeight, setFormHeight] = useState(0)
  const [step, setStep] = useState(1)
  const [unregistredEmail, setUnregistredEmail] = useState(false)

  const containerRef = React.useRef(null)

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [errors, setErrors] = useState({})

  const slideRef = useRef(null)
  const slideRef2 = useRef(null)
  const slideRef3 = useRef(null)
  const slideRefU = useRef(null)
  const slideRef4 = useRef(null)

  useEffect(() => {
    if (query.get('email')) {
      setForm({ ...form, email: query.get('email') })
    }
    if (query.get('error')) {
      setErrors({ ...errors, tokenError: query.get('error') })
    }
  }, [])

  const validateEmail = () => {
    let errors = {}

    if (!form.email) {
      errors.email = 'Email is required'
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      errors.email = 'Email is invalid'
    }

    if (!tsAndCsRead) {
      errors.terms = true
    }

    setErrors(errors)
    return Object.keys(errors).length === 0
  }

  const validateName = () => {
    let errors = {}

    if (!form.name) {
      errors.name = 'Name is required'
    }
    if (!form.lastName) {
      errors.lastName = 'Last Name is required'
    }

    setErrors(errors)
    return Object.keys(errors).length === 0
  }
  const validateCompany = () => {
    let errors = {}

    if (!form.companyName) {
      errors.companyName = 'Company Name is required'
    }

    if (!form.industry) {
      errors.industry = 'Industry is required'
    }

    if (!form.language) {
      errors.language = 'Language is required'
    }

    setErrors(errors)
    return Object.keys(errors).length === 0
  }

  const handleNext = e => {
    e.preventDefault()

    if (step == 1 && validateEmail()) {
      setLoading(true)
      companyService
        .validateDomain(form.email)
        .then(() => {
          setLoading(false)
          setStep(2)
        })
        .catch(err => {
          if (err.response.data.code == 'COMPANY_ERROR_005') {
            setLoading(false)
            setUnregistredEmail(true)
          } else {
            setLoading(false)
            console.error(err)
            setErrors({
              ...errors,
              email: err.response.data.description
                .replace('%s', form.email.split('@')[1])
                .replace('Registration denied: ', '')
            })
          }
        })
    }

    if (step == 2 && validateName()) {
      setStep(3)
    }
  }

  const handleCreate = e => {
    e.preventDefault()

    if (step == 3 && validateCompany()) {
      setLoading(true)
      const body = {
        userEmail: form.email,
        userFirstName: form.name,
        userLastName: form.lastName,
        companyName: form.companyName,
        companyIndustry: form.industry,
        companyLanguage: form.language,
        sourceUrl: window.location.hostname
      }
      companyService
        .registerCompany(body)
        .then(() => {
          setStep(4)
        })
        .catch(err => {
          setLoading(false)
          console.error(err)
          setError(err.response.data.description || 'Something went wrong')
        })
    }
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setError(false)
  }

  useEffect(() => {
    setFormHeight(
      step == 1
        ? slideRef?.current?.clientHeight || 450
        : step == 2
          ? slideRef2?.current?.clientHeight
          : step == 3
            ? slideRef3?.current?.clientHeight
            : step == 4
              ? slideRef4?.current?.clientHeight
              : slideRefU?.current?.clientHeight
    )
  }, [step])

  return (
    <div className='registration-page column'>
      <div className='logo'>
        <img src='images/njsig-logo-1.png' style={{ width: 200 }} alt='' />
      </div>
      <form
        ref={containerRef}
        className='registration-form-container row'
        style={{
          height: formHeight + (errors?.email ? 30 : 0) + 72 + 'px'
        }}
      >
        {unregistredEmail ? (
          <div ref={slideRefU} className='column'>
            <div className='column column-center'>
              <svg
                style={{ marginBottom: '24px' }}
                width='112'
                height='112'
                viewBox='0 0 112 112'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  opacity='0.16'
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M56 112C86.9279 112 112 86.9279 112 56C112 25.0721 86.9279 0 56 0C25.0721 0 0 25.0721 0 56C0 86.9279 25.0721 112 56 112Z'
                  fill='#00BC62'
                />
                <g filter='url(#filter0_d_360_35055)'>
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M79.7744 38.82C78.648 37.4334 76.6041 37.2221 75.2205 38.351L47.5584 60.8834L36.3493 54.4157C35.1674 53.7316 33.6784 53.8707 32.6407 54.753C31.2812 55.9098 31.1129 57.9619 32.2652 59.3263L39.3125 67.6496L39.2977 67.6626L44.7821 74.1174L44.9929 74.3435C45.6218 74.9478 46.432 75.25 47.2403 75.25C48.0893 75.25 48.9346 74.9182 49.5691 74.2638L79.5895 43.1207C80.7289 41.9417 80.8084 40.0936 79.7744 38.82Z'
                    fill='url(#paint0_linear_360_35055)'
                  />
                </g>
                <defs>
                  <filter
                    id='filter0_d_360_35055'
                    x='31.5'
                    y='37.625'
                    width='49'
                    height='39.125'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                  >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                      in='SourceAlpha'
                      type='matrix'
                      values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                      result='hardAlpha'
                    />
                    <feOffset dy='1.5' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                      type='matrix'
                      values='0 0 0 0 0.0032804 0 0 0 0 0.61672 0 0 0 0 0.347725 0 0 0 1 0'
                    />
                    <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_360_35055' />
                    <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_360_35055' result='shape' />
                  </filter>
                  <linearGradient
                    id='paint0_linear_360_35055'
                    x1='74.1597'
                    y1='5.09505'
                    x2='38.0323'
                    y2='9.27992'
                    gradientUnits='userSpaceOnUse'
                  >
                    <stop stopColor='#00BA97' />
                    <stop offset='1' stopColor='#00BC62' />
                  </linearGradient>
                </defs>
              </svg>
              <p className='login-title' style={{ textAlign: 'center' }}>
                Thank you for your interest in NJSIG Security Awareness Platform.
              </p>
            </div>
            <p style={{ textAlign: 'center', marginBottom: '0' }} className='reset-pass-description'>
              Our representative will contact you in 24 hours to grant access to the platform.
            </p>
          </div>
        ) : (
          <>
            <div
              ref={slideRef}
              className='column slider-frame'
              style={{
                transform: `translate(-${(slideRef?.current?.offsetWidth + 38) * step - (slideRef?.current?.offsetWidth + 38)}px)`
              }}
            >
              <p className='registration-title' style={{ fontSize: '30px' }}>
                Welcome to NJSIG
                <br /> Security Awareness Platform!
              </p>
              <p
                className='registration-title'
                style={{ marginBottom: 30, opacity: 0.8, marginTop: 20, fontWeight: 600, fontSize: '22px' }}
              >
                Let's start the journey to online security
              </p>
              <LoginInput
                sx={{
                  color: (error || errors.email) && '#B40020',
                  backgroundColor: (error || errors.email) && '#FAF0F2',
                  '& input::-webkit-autofill': {
                    WebkitTextFillColor: '#FAF0F2'
                  },
                  borderRadius: '20px',
                  mb: '-1px'
                }}
                label='Your work Email'
                variant='standard'
                value={form.email}
                // validations={[]}
                onChange={e => {
                  setForm({ ...form, email: e.target.value })
                  setErrors({ ...errors, email: false })
                }}
                error={error || errors.email}
              />
              {(error || errors.email) && <p className='error-text'>{errors.email}</p>}
              <div className='row row-center ts-cs'>
                <CustomCheckbox
                  checked={tsAndCsRead}
                  sx={{ padding: '0px', pr: '8px' }}
                  onChange={(e, b) => {
                    setTsAndCsRead(b)
                    setErrors({ ...errors, terms: false })
                  }}
                />
                <p
                  style={{
                    fontSize: '14px',
                    margin: '0px 8px',
                    ...(errors.terms && {
                      color: '#B40020'
                    })
                  }}
                >
                  I have read and agree to the{' '}
                  <a
                    style={{
                      color: '#6123FF',
                      textDecoration: 'none'
                    }}
                    href='https://admin.gallaghercdc.cyberlift.ai/assets/TERMS%20&%20CONDITIONS%20FOR%20THE%20USE%20OF%20THE%20PROVIDER%20SERVICES%20(EULA).pdf'
                    target='_blank'
                    rel='noreferrer'
                  >
                    Terms and Conditions for the use of the provider services (EULA)
                  </a>
                </p>
              </div>

              <LoadingButton
                // type="submit"
                className='reg-btn'
                loading={loading}
                onClick={handleNext}
                sx={{
                  mt: '15px',
                  borderRadius: '14px',
                  textTransform: 'none',
                  height: '60px',
                  backgroundColor: '#6123FF'
                }}
                variant={'contained'}
              >
                Next Step
              </LoadingButton>
            </div>

            <div
              ref={slideRef2}
              className='column slider-frame'
              style={{
                transform: `translate(-${(slideRef?.current?.offsetWidth + 38) * step - (slideRef?.current?.offsetWidth + 38)}px)`
              }}
            >
              <div onClick={() => setStep(1)} style={{ marginBottom: '24px' }} className='row row-center back-link'>
                <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M15.75 4.5L8.25 12L15.75 19.5'
                    stroke='#6123FF'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                <p>Back to Sign Up</p>
              </div>
              <p className='registration-title'>Your name</p>
              <p style={{ marginBottom: 30 }}>
                Please enter your first and last name to begin creating your personal profile
              </p>
              <LoginInput
                sx={{
                  color: (error || errors.email) && '#B40020',
                  backgroundColor: (error || errors.email) && '#FAF0F2',
                  '& input::-webkit-autofill': {
                    WebkitTextFillColor: '#FAF0F2'
                  },
                  borderRadius: '20px 20px 0px 0px',
                  mb: '-1px'
                }}
                label='Name'
                variant='standard'
                value={form.name}
                validations={[]}
                onChange={e => {
                  setForm({ ...form, name: e.target.value })
                  setErrors({ ...errors, email: false })
                }}
                error={error || errors.email}
              />
              <LoginInput
                sx={{
                  color: (error || errors.email) && '#B40020',
                  backgroundColor: (error || errors.email) && '#FAF0F2',
                  '& input::-webkit-autofill': {
                    WebkitTextFillColor: '#FAF0F2'
                  },
                  borderRadius: '0px 0px 20px 20px',
                  mb: '-1px'
                }}
                label='Last Name'
                variant='standard'
                value={form.lastName}
                validations={[]}
                onChange={e => {
                  setForm({
                    ...form,
                    lastName: e.target.value
                  })
                  setErrors({ ...errors, email: false })
                }}
                error={error || errors.email}
              />
              <LoadingButton
                // type="submit"
                className='reg-btn'
                loading={loading}
                onClick={handleNext}
                sx={{
                  mt: '30px',
                  borderRadius: '14px',
                  textTransform: 'none',
                  height: '60px',
                  backgroundColor: '#6123FF'
                }}
                variant={'contained'}
              >
                Next Step
              </LoadingButton>
            </div>

            <div
              ref={slideRef3}
              className='column slider-frame'
              style={{
                transform: `translate(-${(slideRef?.current?.offsetWidth + 38) * step - (slideRef?.current?.offsetWidth + 38)}px)`
              }}
            >
              <div onClick={() => setStep(2)} style={{ marginBottom: '24px' }} className='row row-center back-link'>
                <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M15.75 4.5L8.25 12L15.75 19.5'
                    stroke='#6123FF'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                <p>Back to Your name</p>
              </div>
              <p className='registration-title'>Company info</p>
              <p style={{ marginBottom: 30 }}>
                Input your company's essential details to tailor your experience & communication
              </p>
              <LoginInput
                sx={{
                  color: (error || errors.companyName) && '#B40020',
                  backgroundColor: (error || errors.companyName) && '#FAF0F2',
                  '& input::-webkit-autofill': {
                    WebkitTextFillColor: '#FAF0F2'
                  },
                  borderRadius: '20px',
                  mb: '20px'
                }}
                label='Name of the company'
                variant='standard'
                value={form.companyName}
                validations={[]}
                onChange={e => {
                  setForm({
                    ...form,
                    companyName: e.target.value
                  })
                  setErrors({ ...errors, email: false })
                }}
                error={errors.companyName}
              />
              <FormControl fullWidth>
                <InputLabel id='Industry'>Industry</InputLabel>
                <InputSelect
                  required
                  MenuProps={{
                    style: {
                      maxHeight: 200
                    }
                  }}
                  sx={{ borderRadius: '20px', mb: '18px' }}
                  error={errors.industry}
                  labelId='Industry'
                  value={form.industry}
                  label='Industry'
                  onChange={e =>
                    setForm({
                      ...form,
                      industry: e.target.value
                    })
                  }
                >
                  {INDUSTRIES.map(el => (
                    <MenuItem key={el} value={el}>
                      {el}
                    </MenuItem>
                  ))}
                </InputSelect>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id='Language'>Company Language</InputLabel>
                <InputSelect
                  required
                  MenuProps={{
                    style: {
                      maxHeight: 200
                    }
                  }}
                  sx={{ borderRadius: '20px', mb: '18px' }}
                  error={errors.language}
                  labelId='Language'
                  value={form.language}
                  label='Company Language'
                  onChange={e =>
                    setForm({
                      ...form,
                      language: e.target.value
                    })
                  }
                >
                  {LANGUAGES.map(el => (
                    <MenuItem key={el} value={el}>
                      {el}
                    </MenuItem>
                  ))}
                </InputSelect>
              </FormControl>

              <LoadingButton
                type='submit'
                className='reg-btn'
                loading={loading}
                onClick={handleCreate}
                sx={{
                  mt: '30px',
                  borderRadius: '14px',
                  textTransform: 'none',
                  height: '60px',
                  backgroundColor: '#6123FF'
                }}
                variant={'contained'}
              >
                Create company
              </LoadingButton>
            </div>
            <div
              ref={slideRef4}
              className='column slider-frame'
              style={{
                transform: `translate(-${(slideRef?.current?.offsetWidth + 38) * step - (slideRef?.current?.offsetWidth + 38)}px)`
              }}
            >
              <div className='column column-center'>
                <svg
                  style={{ marginBottom: '24px' }}
                  width='112'
                  height='112'
                  viewBox='0 0 112 112'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    opacity='0.16'
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M56 112C86.9279 112 112 86.9279 112 56C112 25.0721 86.9279 0 56 0C25.0721 0 0 25.0721 0 56C0 86.9279 25.0721 112 56 112Z'
                    fill='#00BC62'
                  />
                  <g filter='url(#filter0_d_360_35055)'>
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M79.7744 38.82C78.648 37.4334 76.6041 37.2221 75.2205 38.351L47.5584 60.8834L36.3493 54.4157C35.1674 53.7316 33.6784 53.8707 32.6407 54.753C31.2812 55.9098 31.1129 57.9619 32.2652 59.3263L39.3125 67.6496L39.2977 67.6626L44.7821 74.1174L44.9929 74.3435C45.6218 74.9478 46.432 75.25 47.2403 75.25C48.0893 75.25 48.9346 74.9182 49.5691 74.2638L79.5895 43.1207C80.7289 41.9417 80.8084 40.0936 79.7744 38.82Z'
                      fill='url(#paint0_linear_360_35055)'
                    />
                  </g>
                  <defs>
                    <filter
                      id='filter0_d_360_35055'
                      x='31.5'
                      y='37.625'
                      width='49'
                      height='39.125'
                      filterUnits='userSpaceOnUse'
                      colorInterpolationFilters='sRGB'
                    >
                      <feFlood floodOpacity='0' result='BackgroundImageFix' />
                      <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                      />
                      <feOffset dy='1.5' />
                      <feComposite in2='hardAlpha' operator='out' />
                      <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.0032804 0 0 0 0 0.61672 0 0 0 0 0.347725 0 0 0 1 0'
                      />
                      <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_360_35055' />
                      <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_360_35055' result='shape' />
                    </filter>
                    <linearGradient
                      id='paint0_linear_360_35055'
                      x1='74.1597'
                      y1='5.09505'
                      x2='38.0323'
                      y2='9.27992'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stopColor='#00BA97' />
                      <stop offset='1' stopColor='#00BC62' />
                    </linearGradient>
                  </defs>
                </svg>
                <p className='login-title'>Link sent!</p>
              </div>
              <p
                style={{
                  textAlign: 'center',
                  marginBottom: '0'
                }}
                className='reset-pass-description'
              >
                We've sent magic link to login to <br />
                <span style={{ fontWeight: '600' }}>{form.email}</span>
              </p>
              <p
                style={{
                  textAlign: 'center',
                  marginBottom: '64px'
                }}
                className='reset-pass-description'
              >
                Check your inbox (and spam folder) for an email from us —if you don't receive an email, try another
                email.
              </p>
            </div>
          </>
        )}
      </form>
      <div className='spacer'></div>
      <Copyright />
      <Snackbar
        sx={{
          '& .MuiSnackbarContent-root': {
            backgroundColor: '#B40020',
            borderRadius: '8px'
          }
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        open={error}
        autoHideDuration={6000}
        onClose={handleClose}
        message={error}
      />
      <Snackbar
        sx={{
          '& .MuiSnackbarContent-root': {
            backgroundColor: '#B40020',
            borderRadius: '8px'
          }
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        open={!!errors?.tokenError}
        autoHideDuration={6000}
        onClose={handleClose}
        message={errors?.tokenError}
      />
    </div>
  )
}

export default RegistrationPage
